(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["plugwhip-contact"]) return;
  try {
    
const fillPlugWhipEnquiry = () => {
  const form = document.getElementById('PlugWhipContact');
  if (!form) return;
  const params = new URLSearchParams(window.location.search);
  const makes = { BMW: ['3 Series', '4 Series', '5 Series', 'M3', 'M4', 'M5'], 'Mercedes-Benz': ['C-Class'], Audi: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'S1', 'S2', 'S3', 'S4', 'S5'] };
  const make = params.get('make');
  const model = params.get('model');
  const part = params.get('part');
  if (Object.prototype.hasOwnProperty.call(makes, make)) {
    const makeField = form.querySelector('#pw-make');
    const modelField = form.querySelector('#pw-model');
    if (makeField && !makeField.value) makeField.value = make;
    if (modelField && !modelField.value && makes[make].includes(model)) modelField.value = model;
  }
  if (['front-lips-splitters', 'headlights', 'steering-wheels', 'window-tint', 'carplay-retrofit-kits', 'badges'].includes(part)) {
    const partField = form.querySelector('#pw-part');
    if (partField && !partField.value) partField.value = part;
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillPlugWhipEnquiry, { once: true });
else fillPlugWhipEnquiry();
document.addEventListener('shopify:section:load', fillPlugWhipEnquiry);

  } catch(e) { console.error(e); }
})();
})();
